﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            "availableReasonImageUrls": Object
        }
    }

    static get targets() {
        return ["customReason", "reasonImage", "details", "addAnEmojiButton", "emojiPicker"];
    }

    async connect() {
        if (this.hasEmojiPickerTarget) {
            const {data, Picker} = await import("imports/emoji-mart");
            const picker = new Picker({
                data,
                onEmojiSelect: (e) => {
                    this.insertEmoji(e.native);
                }
            });
            this.emojiPickerTarget.appendChild(picker);
        }
    }

    toggleCustomReasonAndDisplayImageForSelectedReason({ target }) {
        const availableReasonImageUrl = this.availableReasonImageUrlsValue[target.value];
        this.customReasonTarget.classList.toggle("d-none", target.value !== "0");
        if (this.hasReasonImageTarget) {
            this.reasonImageTarget.src = availableReasonImageUrl;
            this.reasonImageTarget.classList.toggle("d-none", !availableReasonImageUrl);
        }
    }

    insertEmoji(emoji) {
        const selectionStart = this.detailsTarget.selectionStart;
        const selectionEnd = this.detailsTarget.selectionEnd;
        this.detailsTarget.value = this.detailsTarget.value.substring(0, selectionStart) + emoji + this.detailsTarget.value.substring(selectionEnd, this.detailsTarget.value.length);
        this.detailsTarget.selectionStart = selectionStart + emoji.length;
        this.detailsTarget.selectionEnd = this.detailsTarget.selectionStart;
        bootstrap.Dropdown.getOrCreateInstance(this.addAnEmojiButtonTarget).hide();
        this.detailsTarget.focus();
    }
}